// @ts-nocheck — migrated from JS; reactstrap / react-select / layout prop friction.
import React, { Fragment, useState, useCallback } from "react";
import { Colxx, Separator } from "Components/CustomBootstrap";
import BreadcrumbContainer from "Components/BreadcrumbContainer";
import IntlMessages from "Util/IntlMessages";
import {
  Row,
  Card,
  CardBody,
  CardTitle,
  Tooltip,
  Button,
  UncontrolledTooltip
} from "reactstrap";
import { SHORTCODE_LINK_DEMO } from "Constants/reactifyInlineStyles";

export default function TooltipPage() {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [tooltipTopOpen, setTooltipTopOpen] = useState(false);
  const [tooltipBottomOpen, setTooltipBottomOpen] = useState(false);
  const [tooltipLeftOpen, setTooltipLeftOpen] = useState(false);
  const [tooltipRightOpen, setTooltipRightOpen] = useState(false);

  const toggle = useCallback(() => {
    setTooltipOpen((v) => !v);
  }, []);
  const toggletop = useCallback(() => {
    setTooltipTopOpen((v) => !v);
  }, []);
  const togglebottom = useCallback(() => {
    setTooltipBottomOpen((v) => !v);
  }, []);
  const toggleleft = useCallback(() => {
    setTooltipLeftOpen((v) => !v);
  }, []);
  const toggleright = useCallback(() => {
    setTooltipRightOpen((v) => !v);
  }, []);

  return (
    <Fragment>
      <Row>
        <Colxx xxs="12">
          <BreadcrumbContainer
            heading={<IntlMessages id="menu.tooltip" />}
          />
          <Separator className="mb-5" />
        </Colxx>
      </Row>

      <Row>
        <Colxx xxs="12">
          <Card className="mb-4">
            <CardBody>
              <CardTitle>
                <IntlMessages id="tooltip.in-the-link" />
              </CardTitle>
              <div>
                <p>
                  Somewhere in here is a{" "}
                  <span
                    style={SHORTCODE_LINK_DEMO}
                    href="#"
                    id="TooltipExample"
                  >
                    tooltip
                  </span>
                  .
                </p>
                <Tooltip
                  placement="right"
                  isOpen={tooltipOpen}
                  target="TooltipExample"
                  toggle={toggle}
                >
                  Hello world!
                </Tooltip>
              </div>
            </CardBody>
          </Card>
        </Colxx>
        <Colxx xxs="12">
          <Card className="mb-4">
            <CardBody>
              <CardTitle>
                <IntlMessages id="tooltip.placements" />
              </CardTitle>
              <div>
                <span>
                  {/* Tooltip top */}
                  <Button
                    className="mr-2 mb-2"
                    color="primary"
                    id="toptooltip"
                  >
                    Tooltip Top
                  </Button>
                  <Tooltip
                    placement="top"
                    isOpen={tooltipTopOpen}
                    target="toptooltip"
                    toggle={toggletop}
                  >
                    Tooltip Content!
                  </Tooltip>

                  {/* Tooltip Left */}
                  <Button
                    className="mr-2 mb-2"
                    color="primary"
                    id="bottomTooltip"
                  >
                    Tooltip Bottom
                  </Button>
                  <Tooltip
                    placement="bottom"
                    isOpen={tooltipBottomOpen}
                    target="bottomTooltip"
                    toggle={togglebottom}
                  >
                    Tooltip Content!
                  </Tooltip>

                  {/* Tooltip Left */}
                  <Button
                    className="mr-2 mb-2"
                    color="primary"
                    id="leftTooltip"
                  >
                    Tooltip Bottom
                  </Button>
                  <Tooltip
                    placement="left"
                    isOpen={tooltipLeftOpen}
                    target="leftTooltip"
                    toggle={toggleleft}
                  >
                    Tooltip Content!
                  </Tooltip>

                  {/* Tooltip Left */}
                  <Button
                    className="mr-2 mb-2"
                    color="primary"
                    id="rightTooltip"
                  >
                    Tooltip Bottom
                  </Button>
                  <Tooltip
                    placement="right"
                    isOpen={tooltipRightOpen}
                    target="rightTooltip"
                    toggle={toggleright}
                  >
                    Tooltip Content!
                  </Tooltip>
                </span>
              </div>
            </CardBody>
          </Card>
        </Colxx>
        <Colxx xxs="12">
          <Card className="mb-4">
            <CardBody>
              <CardTitle>
                <IntlMessages id="tooltip.UncontrolledTooltip" />
              </CardTitle>
              <div>
                {/* Tooltip top */}
                <p>
                  UncontrolledTooltip{" "}
                  <span
                    style={SHORTCODE_LINK_DEMO}
                    href="#"
                    id="UncontrolledTooltip"
                  >
                    tooltip
                  </span>
                  .
                </p>
                <UncontrolledTooltip
                  placement="right"
                  target="UncontrolledTooltip"
                >
                  Hello world!
                </UncontrolledTooltip>

                {/* Tooltip with HTML */}

                {/* Tooltip top */}
                <p>
                  UncontrolledTooltip with HTML{" "}
                  <span
                    style={SHORTCODE_LINK_DEMO}
                    href="#"
                    id="UncontrolledTooltipHTML"
                  >
                    tooltip
                  </span>
                  .
                </p>
                <UncontrolledTooltip
                  placement="right"
                  target="UncontrolledTooltipHTML"
                >
                  <em>Tooltip</em> <u>with</u> <b>HTML</b>
                </UncontrolledTooltip>
              </div>
            </CardBody>
          </Card>
        </Colxx>
      </Row>
    </Fragment>
  );
}
